/*
 * (c) Copyright, 2022, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useRcmTableData } from '../../hooks/useRcmTableData'
import { useServiceContext } from '../../root'

interface GridTableSwitchProps {
  [key: string]: any
}

export const GridTableSwitch: React.FC<GridTableSwitchProps> = (props) => {
  const tableData = useRcmTableData()
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()

  return (
    <button
      {...props}
      className="btn-icon btn-grid-view"
      title={translate(tableData.isGridView ? 'LIST_VIEW_TOOLTIP' : 'THUMB_VIEW_TOOLTIP')}
      onClick={() => {
        tableData.setIsGridView(!tableData.isGridView)
      }}
    >
      <i className={'v-align-bottom ' + (tableData.isGridView ? 'icon-list' : 'icon-box')} />
    </button>
  )
}
